import { Capacitor } from '@capacitor/core';
import { CurrencyExchange } from '@mui/icons-material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import { Tooltip } from '@mui/material';
import { blue } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import UploadGroupDataDialog from '@sophocles/components/UploadGroupDataDialog';
import { determineIsAccounting, determineIsCustomerAdmin, userPermCheck } from '@sophocles/utils/userPermissionUtils';

function CustomerTitleItems({ user, params, page, customer }) {
  const { t } = useTranslation();

  const isStaff = user.get('is_staff', false);
  const isSuperUser = user.get('is_superuser', false);
  const groups = user.get('groups', []);

  const isNativePlatform = Capacitor.isNativePlatform();

  const canEditCustomer =
    isStaff || determineIsCustomerAdmin(groups) || userPermCheck(user, 'pliny.change_sitegroupmembership');

  const isAccounting = isSuperUser || determineIsAccounting(groups);

  const customerId = customer?.id ?? null;
  const billingAccountId = customer?.billing_account_id ?? null;

  return (
    <div style={{ marginRight: '8px' }}>
      {isAccounting && !isNativePlatform && (
        <Link to={`/billing/accounts/${billingAccountId}`}>
          <Tooltip title="Billing">
            <IconButton>
              <CurrencyExchange style={{ fill: 'var(--text-secondary)' }} />
            </IconButton>
          </Tooltip>
        </Link>
      )}
      {isStaff && !isNativePlatform && customerId && <UploadGroupDataDialog customerId={customerId} />}
      {!isNativePlatform && (
        <Link to={`/c/${params.cust_id}/users?c=${params.cust_id}`}>
          <Tooltip title={t('general.users')}>
            <IconButton>
              <PeopleIcon style={{ fill: page === 'users' ? blue[500] : 'var(--text-secondary)' }} />
            </IconButton>
          </Tooltip>
        </Link>
      )}
      {!isNativePlatform && (
        <Link to={`/c/${params.cust_id}/reports`}>
          <Tooltip title={t('general.reports')}>
            <IconButton>
              <AssessmentIcon style={{ fill: page === 'reports' ? blue[500] : 'var(--text-secondary)' }} />
            </IconButton>
          </Tooltip>
        </Link>
      )}
    </div>
  );
}

export default CustomerTitleItems;
